
import React, { useRef, useState } from 'react'
import useClickOutside from '@apex/lib/hooks/useClickOutside'
import useEscape from '@apex/lib/hooks/useEscape'
import { X } from 'react-feather'
import Overlay from './Overlay'
import Title from './Title'
import Box from './Box'


/**
 * SideSheet component.
 */

export default SideSheet

/**
 * SideSheet component.
 */

function SideSheet({ content, expanded, children, onClose, onCloseComplete, hasClose = true, ...props }) {
  const [animate, setAnimate] = useState("show")
  const ref = useRef(null)

  useClickOutside(ref, close)
  useEscape(close)

  function close() {
    setAnimate("hide")
    if (onClose) onClose()
    if (onCloseComplete) setTimeout(_ => onCloseComplete(), 200)
  }

  return <Overlay>
    <Box className="SideSheet" classes={animate} innerRef={ref} {...props}>
      {hasClose && <Close onClick={close} />}
      {children}
      {content && content({ close })}
    </Box>
  </Overlay>
}

/**
 * Expose components.
 */

SideSheet.Title = SheetTitle

/**
 * SheetTitle component.
 */

function SheetTitle({ text, subtext }) {
  return <Box flexShrink={false} background={0} borderBottom>
    <Box padding={8}>
      <Title
        size={2}
        text={text}
        subtext={subtext} />
    </Box>
  </Box>
}

/**
 * Close component.
 */

function Close({ ...props }) {
  return <Box cursor="pointer" className="close" {...props}>
    <X size={14} />
  </Box>
}